/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for VfbHookCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class VfbHookCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    omHook(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook1(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook1(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook1(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook1(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook2(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook2(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook2(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook2(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook4(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook4(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook4(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook4(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook3(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook3(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook3(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook3(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook6(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook6(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook6(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook6(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook5(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook5(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook5(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook5(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/vfb`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
